import React, { useState, useEffect } from "react";
import moment from "moment-hijri";
import "moment/locale/ar";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "../HumanCalculator/MainCalculators";
import imgUrl from "../../../images/current-date.webp"
const TITLE = "تاريخ اليوم ميلادي وهجري - معرفة التاريخ الحالي";
const DESCRIPTION =
  "عرض التاريخ الحالي بالتقويم الميلادي والهجري مع تفاصيل اليوم والساعة. معرفة تاريخ اليوم بدقة حسب التقويمين الميلادي والهجري.";
const KEYWORDS =
  "تاريخ اليوم, التاريخ الميلادي, التاريخ الهجري, التقويم الميلادي, التقويم الهجري, تاريخ اليوم ميلادي, تاريخ اليوم هجري, تحويل التاريخ";
const OG_URL = "https://do-calculate.com/calculator/ar/current-date/";
const arabicMonths = [
  "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
  "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
];
const arabicDays = [
  "الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"
];
const arabicHijriMonths = [
  "محرم", "صفر", "ربيع الأول", "ربيع الآخر",
  "جمادى الأولى", "جمادى الآخرة", "رجب", "شعبان",
  "رمضان", "شوال", "ذو القعدة", "ذو الحجة"
];
moment.locale("ar");
function CurrentDateDisplay() {
  const [currentTime, setCurrentTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const dayName = arabicDays[currentTime.getDay()];
  const day = currentTime.getDate();
  const month = arabicMonths[currentTime.getMonth()];
  const year = currentTime.getFullYear();
  const gregorianDate = `${dayName}، ${day} ${month} ${year}`;
  let hours = currentTime.getHours();
  const ampm = hours >= 12 ? "م" : "ص";
  hours = hours % 12 || 12;
  const minutes = currentTime.getMinutes().toString().padStart(2, "0");
  const seconds = currentTime.getSeconds().toString().padStart(2, "0");
  const gregorianTime = `${hours}:${minutes}:${seconds} ${ampm}`;
  const hijriMoment = moment(currentTime);
  const hijriDay = hijriMoment.iDate();
  const hijriMonthIndex = hijriMoment.iMonth();
  const hijriMonth = arabicHijriMonths[hijriMonthIndex];
  const hijriYear = hijriMoment.iYear();
  const hijriWeekday = hijriMoment.format("dddd");
  const hijriDate = `${hijriWeekday}، ${hijriDay} ${hijriMonth} ${hijriYear}`;
  const hijriTime = hijriMoment.format("hh:mm:ss A").replace("AM", "ص").replace("PM", "م");
  return (
    <div style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={imgUrl}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4">
          <img
            src={imgUrl}
            alt={
              "تاريخ اليوم ميلادي وهجري - معرفة التاريخ الحالي"
            }
            width="300px"
            height="300px"
          />
        </div>
      </div>
      <br />
      <MobileUnderCalAds />
      <div className="row">
        <div className="col-12 col-md-7 calculatorStyle">
          <div className="p-3 mb-2 bg-success text-white text-center rounded">
            <h1 style={{ fontSize: "20px" }}>تاريخ اليوم ميلادي وهجري</h1>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="card h-100 border-success">
                <div className="p-3 mb-2 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "16px" }}>التاريخ الميلادي</h2>
                </div>
                <div className="text-center">
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#28a745" }}>
                    {gregorianDate}
                  </div>
                  <div className="mt-2" style={{ fontSize: "18px" }}>
                    {gregorianTime}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card h-100 border-success">
                <div className="p-3 mb-2 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "16px" }}>التاريخ الهجري</h2>
                </div>
                <div className="text-center">
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#28a745" }}>
                    {hijriDate}
                  </div>
                  <div className="mt-2" style={{ fontSize: "18px" }}>
                    {hijriTime}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="alert alert-info mt-4">
            <p className="mb-0">
              يعرض هذا القسم التاريخ الحالي حسب التقويم الميلادي (الغريغوري) والتقويم الهجري (القمري) مع الوقت الحالي. يتم تحديث البيانات تلقائياً حسب توقيت جهازك.
            </p>
          </div>

        </div>

        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row">
        <RelatedLinks />
        <hr />
      </div>
      <div className="row">
        <div className="col-12 col-md-8" >
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">التاريخ الهجري والميلادي اليوم - تحويل التاريخ بين التقويمين</div>
              <div className="info-section-body">
                <div>
                  <h3 className="text-success">التاريخ اليوم هجري وميلادي بتوقيت دولتك</h3>
                  <p>
                    تقدم خدمتنا عرضًا دقيقًا للتاريخ الهجري والميلادي اليوم حسب توقيتك المحلي. نوفر التاريخ بعدة صيغ مختلفة تشمل الصيغة الرقمية الكاملة، والصيغة المختلطة (أرقام ونصوص)، والصيغة النصية الكاملة باستخدام التفقيط لضمان أعلى درجات الدقة والوضوح.
                  </p>
                  <div className="row mt-4">
                    <div className="col-md-6 mb-3">
                      <div className="border p-3 h-100 rounded">
                        <h4 className="text-success">التقويم الميلادي (التاريخ الغريغوري)</h4>
                        <p style={{ textAlign: "justify" }}>
                          التقويم الميلادي هو النظام التقويمي الأكثر استخدامًا عالميًا، يعتمد على دورة الأرض حول الشمس (365.25 يوم). يتم استخدامه في المعاملات الرسمية الدولية ويبدأ من سنة ميلاد المسيح. يعتبر التقويم الرسمي في معظم الدول العربية باستثناء المملكة العربية السعودية.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="border p-3 h-100 rounded">
                        <h4 className="text-success">التقويم الهجري (التاريخ القمري الإسلامي)</h4>
                        <p style={{ textAlign: "justify" }}>
                          التقويم الهجري هو التقويم الرسمي في المملكة العربية السعودية، يعتمد على دورة القمر (29.5 يوم). يستخدم لتحديد المناسبات الإسلامية مثل رمضان والحج. بدأ من هجرة النبي محمد ﷺ ويقل عن الميلادي بـ11 يومًا سنويًا.
                        </p>
                      </div>
                    </div>
                  </div>
                  <h3 className="mt-4">كيف يتم تحديد التاريخ الهجري والميلادي اليوم؟</h3>
                  <p>
                    نعتمد في عرض التاريخ الميلادي على توقيت نظام التشغيل حسب منطقتك الزمنية. أما التحويل بين التاريخين فيتم عبر خوارزميات حسابية دقيقة تم تطويرها خصيصًا لضمان مطابقة التاريخ الهجري مع الميلادي بدقة تامة، مع مراعاة فروق التوقيت بين الدول.
                  </p>
                  <h4>دقة التحويل بين التاريخ الهجري والميلادي</h4>
                  <p>
                    يتم تدقيق عمليات التحويل بين النظامين بشكل دوري للتأكد من مطابقة التاريخ المعروض مع المراجع الفلكية المعتمدة. نحرص على تحديث البيانات وفقًا لأحدث الحسابات الفلكية.
                  </p>
                  <h3 className="mt-4">مميزات خدمة عرض التاريخ اليوم</h3>
                  <h4>عرض التاريخ حسب توقيتك المحلي</h4>
                  <p>
                    نعرض التاريخ الهجري والميلادي حسب توقيت الدولة التي تتصل منها. إذا كنت خارج الوطن العربي، نقدم خيار عرض التوقيت العالمي مع تنبيه بالمنطقة الزمنية.
                  </p>
                  <h4>تنسيقات متعددة للتاريخ</h4>
                  <p>
                    نوفر التاريخ بعدة صيغ لتلبية مختلف الاحتياجات: رقمية كاملة (1445/12/25)، مختلطة (25 ذو الحجة 1445)، نصية كاملة (الخامس والعشرون من ذو الحجة سنة ألف وأربعمائة وخمسة وأربعون هجرية).
                  </p>
                  <h4>أداة تحويل التاريخ بين الهجري والميلادي</h4>
                  <p>
                    يمكنك التحويل بين التاريخين بسهولة عبر أداتنا التفاعلية التي توفر نتائج فورية ودقيقة مع إمكانية عرض التواريخ المقبلة للمناسبات الإسلامية.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
export default CurrentDateDisplay;